import React, { ReactElement } from "react";
import {
  InbrengEigenGeldData,
  ToelichtingInbrengEigenGeldHoofdstuk,
} from "../../../../../../.generated/rapportage/rapportagetypes";
import { Motivering } from "../../../../components/Motivering";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";
import Table from "../../../../components/Table";
import { Column } from "../../../../components/BaseTable";
import { formatCurrency } from "../../../../../formatters";

const inbrengEigenGeldTable = (
  inbrengEigenGeld: InbrengEigenGeldData
): ReactElement => {
  const columnsInbrengEigenGeld: Column<InbrengEigenGeldData>[] = [
    {
      header: "",
      accessor: () => "",
    },
    {
      header: "Bedrag inbreng eigen geld",
      accessor: "inbrengEigenGeld",
      dataType: "currency",
    },
    {
      header: "Inbreng eigen middelen voor verlagen restschuld",
      accessor: (row: InbrengEigenGeldData) =>
        formatCurrency(row.inbrengEigenGeldRestschuld ?? 0),
    },
    {
      header: "Inbreng verwachte overwaarde",
      accessor: (row: InbrengEigenGeldData) =>
        formatCurrency(row.inbrengEigenGeldOverwaarde ?? 0),
    },
    {
      header: "Extra aflossing",
      accessor: (row: InbrengEigenGeldData) =>
        formatCurrency(row.extraAflossing ?? 0),
    },
    {
      header: inbrengEigenGeld.eigenGeldOverig1
        ? "Bedrag overig eigen geld - 1"
        : "",
      accessor: "eigenGeldOverig1",
      dataType: "currency",
    },
    {
      header: inbrengEigenGeld.eigenGeldOverig2
        ? "Bedrag overig eigen geld - 2"
        : "",
      accessor: "eigenGeldOverig2",
      dataType: "currency",
    },
  ];

  const columnsInbrengPolis: Column<InbrengEigenGeldData>[] = [
    {
      header: "Inbreng polis / rekening",
      accessor: () => "",
    },
    {
      header: "Inbreng opgebouwde waarde",
      accessor: (row: InbrengEigenGeldData) =>
        formatCurrency(row.inbrengOpgebouwdeWaarde ?? 0),
    },
    {
      header: "Bedrag inbreng eigen geld overig",
      accessor: "eigenGeldInbrengOverig1",
      dataType: "currency",
    },
    {
      header: "Omschrijving inbreng eigen geld overig",
      accessor: "eigenGeldInbrengOverig1Omschrijving",
    },
    {
      header: "Inbreng voor verlagen restschuld",
      accessor: "eigenGeldInbrengRestschuld",
      dataType: "currency",
    },
  ];

  const data = [inbrengEigenGeld];

  return (
    <>
      <Table<InbrengEigenGeldData>
        rotate
        columns={columnsInbrengEigenGeld}
        data={data}
        id="inbreng-eigen-geld-table"
      />
      <Table<InbrengEigenGeldData>
        rotate
        columns={columnsInbrengPolis}
        data={data}
        id="inbreng-eigen-polis-table"
      />
    </>
  );
};

export const ToelichtingInbrengEigenGeldChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingInbrengEigenGeldHoofdstuk;
}): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text="Inbreng eigen geld" level={3} />
        <Motivering
          wens={hoofdstuk.wensen}
          advies={hoofdstuk.adviesen}
          keuze={hoofdstuk.keuzes}
        />
        {hoofdstuk.inbrengEigenGeld &&
          inbrengEigenGeldTable(hoofdstuk.inbrengEigenGeld)}
      </div>
    </Chapter>
  );
};
